































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { WalletUpdateRequestModel } from '@/modules/wallet/models/wallet-request.model'
import { WalletIncreaseType, WalletType } from '@/modules/wallet/models/wallet-resource.model'
import CurrencyView from '@/modules/shared/components/shared/CurrencyView.vue'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import Radio from '@/modules/shared/components/shared/kit/Radio.vue'
import { UserWalletUpdateUseCase } from '@/modules/user/use-cases/admin/user-wallet-update.use-case'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'

@Component({
  components: { BaseCard, Radio, Toggle, BaseButton, BaseInput, CurrencyInput, CurrencyView }
})
export default class AdminUserWalletUpdateForm extends Vue {
  constructor(
    private readonly userWalletUpdateUseCase: UserWalletUpdateUseCase
  ) {
    super()
  }

  @Prop({ required: true }) value!: number
  @Prop({ required: true }) userId!: number
  @Prop({ default: WalletType.USER }) walletType !: WalletType
  private walletUpdateRequest: WalletUpdateRequestModel = this.initRequest()

  onSubmit() {
    this.userWalletUpdateUseCase.execute(this.userId, this.walletUpdateRequest).then(() => {
      if (this.userWalletUpdateUseCase.isSuccess) {
        this.$emit('update', true)
        this.walletUpdateRequest = this.initRequest()
      }
    })
  }

  initRequest(): WalletUpdateRequestModel {
    return {
      amount: null,
      description: null,
      send_notify: true,
      type: WalletIncreaseType.INC,
      wallet_type: this.walletType
    }
  }
}
